<template>

  <div class="planning-wrapper scrollable">
    <div class="table-content">
      <ul class="table-head">
        <li class="row">
          <ul>
            <li class="day-column column"></li>
            <li :class="{ 'displayed' : index % 3 === 0}" class="column hour-column" v-for="(hour, index) in hours" :key="index">
              <p>{{ $t(`dash.hour.${hour}`) }}</p>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="table-body scrollable">
        <li class="row" v-for="(day, key) in week" :key="key">
          <ul>
            <li class="day-column column">
              <p>{{ $t(`dash.week.${key}`) }}</p>
            </li>
            <!--<li class="column cta day">
              <vs-button @click="setPlanning('day', key, false)">-</vs-button>
            </li>-->
            <li class="column" :class="{ 'bordered' : index % 3 === 0, 'unbordered' : index % 3 === 2}" v-for="(hour, index) in day" :key="index">
              <div class="hour-wrapper" 
                draggable
                @dragstart='startDrag($event, key+index)'
                @drop='onDrop($event, key+index)' 
                @dragover.prevent
              >
                <input type="checkbox" name="hour" :value="key+index" v-model="checkedNames" @change="change(key, index, 1)">
                <div class="hour-checkbox"></div>
              </div>
            </li>
            <!--<li class="column cta day">
              <vs-button @click="setPlanning('day', key, true)">+</vs-button>
            </li>-->
          </ul>
        </li>
        <li class="row cta hour">
          <ul>
            <li class="column" v-for="(day, key) in hours" :key="key">
              <vs-button v-if="checkStateAdd(key)" @click="setPlanning('hour', key, true)" color="#303030">+</vs-button>
              <vs-button v-else @click="setPlanning('hour', key, false)" color="#303030">-</vs-button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
    
</template>

<script>


export default {
  name: 'component-planning',

  props: {
    week: Object,
  },

  data() {
    return {
      hours : ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", 
      "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"],
      checkedNames: []
    }
  },

  mounted() {
    //init planning with week prop
    for(const day in this.week){
      for(const hour in this.week[day]){
        if(this.week[day][hour]) this.checkedNames.push(day+hour)
      }
    } 
  },
  
  methods: {
    /**
     * Emit submit event to parent
     * @private
     */
    change(day, hour) {
      this.$emit('change', day, hour)
    },

    checkStateAdd(hour){
      let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      let stateAdd = true
      days.forEach(d => {
        if(this.checkedNames.includes(d+hour))
          stateAdd = false
      })
      return stateAdd
    },

    setPlanning(type, value, add) {
      if(type == 'day'){
        for(let h=0; h<24; h++){
          if(add && !this.checkedNames.includes(value+h)){
            this.checkedNames.push(value+h)
            this.$emit('change', value, h)
          }
          else if(!add && this.checkedNames.includes(value+h)){
            const index = this.checkedNames.indexOf(value+h);
            this.checkedNames.splice(index, 1);
            this.$emit('change', value, h)
          }
        }
      }
      else {
        let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        days.forEach(d => {
          if(add && !this.checkedNames.includes(d+value)){
            this.checkedNames.push(d+value)
            this.$emit('change', d, value)
          }
          else if(!add && this.checkedNames.includes(d+value)){
            const index = this.checkedNames.indexOf(d+value);
            this.checkedNames.splice(index, 1);
            this.$emit('change', d, value)
          }
        })
      }
    },

    startDrag(evt, startPlanning){
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('startPlanning', startPlanning)
    },

    onDrop (evt, endPlanning) {
      let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      let startPlanning = evt.dataTransfer.getData('startPlanning')

      //get start/end drag&drop
      let startDay, startHour, endDay, endHour
      days.forEach(d => {
        if(startPlanning.includes(d)) {
          startDay = d
          startHour = parseInt(startPlanning.substr(startDay.length))
        }
        if(endPlanning.includes(d)){ 
          endDay = d
          endHour = parseInt(endPlanning.substr(endDay.length))
        }
      })

      for(let d=days.indexOf(startDay); d<=days.indexOf(endDay);){
        for(let h=startHour; h<=endHour;){
          //add slots
          if(this.checkedNames.includes(days[d]+h)){
            const index = this.checkedNames.indexOf(days[d]+h);
            if (index > -1) {
              this.checkedNames.splice(index, 1);
            }
          }
          //remove slots
          else {
            this.checkedNames.push(days[d]+h)
          }

          this.$emit('change', days[d], h)

          if(startHour <= endHour) h++
          else h--
        }

        if(days.indexOf(startDay) <= days.indexOf(endDay)) d++
        else d--
      }
    }

  }
}    
</script>
